import { HttpClient } from '@angular/common/http';
import { environment } from '@prcins/environments';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CancellationProviderService = /** @class */ (function () {
    function CancellationProviderService(http) {
        this.http = http;
        this.apiUrl = environment.BASE_URL + '/v2/';
    }
    /**
     * Creates a cancellation endorsement and returns the guid
     */
    CancellationProviderService.prototype.createCancellationEndorsement = function (type) {
        if (type === void 0) { type = 'PC'; }
        var policyNum = sessionStorage.getItem('currentPolicy');
        return this.http.post(this.apiUrl + 'core/' + policyNum + '/endorsements/cancellation', {});
    };
    /**
     * Checks if a cancellation request already exists for the policy
     */
    CancellationProviderService.prototype.checkCancellationRequestExists = function (policyNum) {
        return this.http.get(environment.BASE_URL + '/policy/cancellation/exists/' + policyNum);
    };
    CancellationProviderService.prototype.checkCancellationEligibility = function (policyNum) {
        return this.http.get(environment.BASE_URL + '/policy/cancellation/' + policyNum);
    };
    CancellationProviderService.prototype.submitCancellationRequest = function (policyNumber, guid, request) {
        var url = environment.BASE_URL + '/policy/cancellation/' + policyNumber + '/endorsements/' + guid;
        return this.http.post(url, request);
    };
    /**
     * Validates uploaded cancellation documents
     */
    CancellationProviderService.prototype.validateCancellationDocuments = function (formData, policyNum, guid) {
        var url = guid
            ? environment.BASE_URL + '/policy/cancellation/' + policyNum + '/validateDocuments/' + guid
            : environment.BASE_URL + '/policy/cancellation/' + policyNum + '/validateDocuments';
        return this.http.post(url, formData);
    };
    CancellationProviderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CancellationProviderService_Factory() { return new CancellationProviderService(i0.ɵɵinject(i1.HttpClient)); }, token: CancellationProviderService, providedIn: "root" });
    return CancellationProviderService;
}());
export { CancellationProviderService };
